import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API } from "../lib/api";
import { useSiteContent } from "../lib/siteContent";
import { SiteHeader } from "../components/SiteHeader";
import { OfferingsStrip } from "../components/OfferingsStrip";
import { SomaticResetStrip } from "../components/SomaticResetStrip";
import { KeyRound } from "lucide-react";

export default function Offerings() {
  const site = useSiteContent();
  const [code, setCode] = useState("");
  const [restoreMsg, setRestoreMsg] = useState(null);
  const [restoring, setRestoring] = useState(false);

  const restore = async (e) => {
    e.preventDefault();
    setRestoring(true); setRestoreMsg(null);
    try {
      const { data } = await axios.post(`${API}/entitlement/restore`, { code });
      localStorage.setItem("bnm-entitlement", JSON.stringify(data));
      setRestoreMsg({ ok: true, text: "Welcome back. Your access has been restored." });
    } catch (e2) {
      setRestoreMsg({ ok: false, text: "That access code wasn't found. Check it and try again." });
    } finally { setRestoring(false); }
  };

  return (
    <div className="min-h-[100dvh]" style={{ background: "linear-gradient(180deg,#F3EFEA 0%,#ECE7DE 100%)" }} data-testid="offerings-page">
      <SiteHeader theme="light" />
      <div className="mx-auto max-w-6xl px-5 py-12 sm:px-8">
        <p className="kicker text-ink-muted">{site?.offerings?.eyebrow || "The Offerings"}</p>
        <h1 className="mt-2 font-display text-4xl text-ink sm:text-5xl">{site?.offerings?.heading || "You do not have to hold the rest alone."}</h1>
        <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-ink-soft">
          A systematic, biopsychosocial map for setting down the quiet endurance your body has carried for years — in whatever measure feels safe to receive.
        </p>
        <Link to="/vault/gallery" data-testid="offerings-gallery-link" className="mt-5 inline-flex items-center gap-2 font-display text-sm text-terracotta underline-offset-4 hover:underline">
          Wander the digital art gallery →
        </Link>

        <OfferingsStrip className="mt-10" />

        <div className="mt-10">
          <p className="kicker mb-3 text-ink-muted">Start gently — it's free</p>
          <SomaticResetStrip />
        </div>

        <form onSubmit={restore} className="mt-14 rounded-2xl border border-ivory-400/60 p-5" data-testid="restore-form">
          <p className="mb-2 inline-flex items-center gap-2 font-display text-sm text-ink"><KeyRound className="h-4 w-4 text-terracotta" /> Already have an access code?</p>
          <div className="flex flex-wrap gap-2">
            <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="BNM-XXXX-XXXX" data-testid="restore-input"
              className="min-w-[180px] flex-1 rounded-lg border border-ivory-400/70 bg-[#FCFBF7] px-3 py-2.5 text-ink focus:outline-none focus:ring-1 focus:ring-terracotta/50" />
            <button type="submit" disabled={restoring || !code} data-testid="restore-submit"
              className="rounded-full bg-ink px-5 py-2.5 font-display text-ivory-50 disabled:opacity-50">Restore</button>
          </div>
          {restoreMsg && <p className={`mt-2 text-sm ${restoreMsg.ok ? "text-emerald-600" : "text-terracotta-deep"}`} data-testid="restore-msg">{restoreMsg.text}</p>}
        </form>
      </div>
    </div>
  );
}
